/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-10 11:43:06
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-10 11:45:33
 * @name: 调用api post方法
 * @Description: 调用api post方法
 * @FilePath: \practice\src\nestVue\common\decorators\Post.js
 * @Author: desktop
 */
import { Api } from "./Api";
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 调用api post方法
 * @param {String} route 调用的路由
 * @param {String} config 调用配置
 * { 
 * type{String}: 模式 search 查 add 增 delete 删 edit 改
 * }
 */
export function Post(route, config) {
  return Api(route, config, 'post');
}